import { useDefaultValue } from '@gef-ui/context-defaults';
import getDisplayName from "@gef-ui/utils/getDisplayName";
import mergeDefaultProps from "@gef-ui/utils/mergeDefaultProps";
import hoistNonReactStatics from 'hoist-non-react-statics';
import curry from "ramda/es/curry";
import React from 'react';
export const ALL_CODELIST = 'ALL_CODELIST';
export const withDefaultCodelistProps = curry((componentName, defaultProps, WrappedComponent)=>{
    const WithDefaultPropsWrapping = (inProps)=>{
        const props = useDefaultValue({
            inProps,
            slice: 'Codelist',
            components: [
                ALL_CODELIST,
                componentName
            ]
        });
        return /*#__PURE__*/ React.createElement(WrappedComponent, mergeDefaultProps(props, defaultProps));
    };
    WithDefaultPropsWrapping.displayName = `withDefaultCodelistProps(${getDisplayName(WrappedComponent)})`;
    hoistNonReactStatics(WithDefaultPropsWrapping, WrappedComponent);
    return WithDefaultPropsWrapping;
});
